import {useTransition} from '@yandex-delivery/blocks'
import React from 'react'

import {genericMemo} from '@yandex-delivery/utils'
import {MapFeature} from '../../index'
import {arePropsEqual, isRoutePoints, jamsToStyle, loadRoute} from '../lib'
import type {RouteProps, RouteType} from '../model'
import {DEFAULT_STYLE, LOAD_ROUTE_KEY} from '../model'

export const Route = genericMemo(
  <TError,>({drawJams = true, onBoundsChange, onError, points, style = DEFAULT_STYLE}: RouteProps<TError>) => {
    const [state, startTransition] = useTransition<RouteType | null>(
      () => loadRoute(points, {onBoundsChange, onError}),
      {
        key: LOAD_ROUTE_KEY,
      },
    )
    const route = state.payload
    const isRouteAvailable = isRoutePoints(points)
    React.useEffect(() => {
      startTransition(() => loadRoute(points, {onBoundsChange, onError}))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [points])

    if (!route || !isRouteAvailable) {
      return null
    }

    return <MapFeature {...route} style={drawJams ? jamsToStyle(route.properties.jams) : style} />
  },
  arePropsEqual,
)
